import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import CheckBox from '../../check-box-group/check-box';
import { exercisePropTypes, HIGHLIGHT_NORMAL, HIGHLIGHT_SUCCESS, HIGHLIGHT_ERROR } from '../../../constants/exercise';
import { getCharByElementPosition } from '../../../lib/exercise';
import MathContent from '../../math-content';
import FluidContainer from '../../layouts/components/fluid-container';
import Spacer from '../../spacer';

const BoxContainer = styled.div`
    width: fit-content;
`;

const SingleAnswerContainer = styled.div`
    display: flex;
    font-size: 16px;
`;

const FeedbackContainer = styled.div`
    margin-top: 8px;

    @media (max-width: 767px) {
        padding-right: 0;
    }
`;

const Label = styled.span`
    font-size: 16px;
    font-weight: 600;
`;

const Index = styled.div`
    font-size: 16px;
    font-weight: 600;
    padding: 28px 16px 0 0;
`;

const Header = styled(FluidContainer)`
    margin: 0 0 0 34px;
    ${(props) => props.theme.mediaQueries.desktop} {
        margin: 0 0 0 32px;
    }
    flex-grow: 0;
`;

const AnswersContainer = styled.div`
    & div:first-child div label {
        margin-top: 0;
    }

    & ${SingleAnswerContainer}:first-child ${Index} {
        padding-top: 16px;
    }
`;

export const getLabel = (answerType, solution, feedback) => {
    if (solution) {
        if (feedback) {
            return 'Feedback specifico. ';
        }
        return '';
    }
    switch (answerType) {
        case 'correct':
            return 'Risposta esatta. ';
        case 'wrong':
            return 'Risposta sbagliata.';
        default:
            return 'Risposta non data. ';
    }
};

export function getFeedbackTypes(answers, options) {
    let answersWithType = [];
    const correctOptionsIds = options.filter((item) => item.correct === true).map((item) => item.id);

    const selectedOptionsIds = answers.answer.map((item) => parseInt(item));

    selectedOptionsIds.map((item) => !correctOptionsIds.includes(item) && answersWithType.push({ id: item, type: 'wrong' }));
    correctOptionsIds.map((item) =>
        selectedOptionsIds.includes(item)
            ? answersWithType.push({ id: item, type: 'correct' })
            : answersWithType.push({ id: item, type: 'missing' }),
    );
    return answersWithType;
}

export const SingleMultipleChoiceCorrection = ({ answerType = null, feedback, index, text, solution }) => {
    const highlight =
        answerType === 'correct' || answerType === 'missing'
            ? HIGHLIGHT_SUCCESS
            : answerType === 'wrong'
              ? HIGHLIGHT_ERROR
              : HIGHLIGHT_NORMAL;
    return (
        <SingleAnswerContainer key={index}>
            <Index>{`${getCharByElementPosition(index + 1)}.`}</Index>
            <div>
                <Spacer size="base" />
                <BoxContainer>
                    <CheckBox disabled={true} highlight={highlight} value={index} selected={answerType === 'correct'}>
                        {text}
                    </CheckBox>
                </BoxContainer>
                {(answerType || solution) && (
                    <FeedbackContainer>
                        <Label>{getLabel(answerType, solution, feedback)}</Label>
                        {feedback && <MathContent style={{ display: 'inline' }}>{feedback}</MathContent>}
                    </FeedbackContainer>
                )}
            </div>
        </SingleAnswerContainer>
    );
};

SingleMultipleChoiceCorrection.propTypes = {
    answerType: PropTypes.string,
    feedback: PropTypes.string,
    index: PropTypes.number,
    text: PropTypes.string,
    solution: PropTypes.bool,
};

const MultipleChoiceCorrection = ({ answers, exercise, solution }) => {
    const selectedAnswers = answers && getFeedbackTypes(answers, exercise.options);
    return (
        <AnswersContainer>
            <Header flexDirection="column">
                {exercise.prompt && <MathContent>{exercise.prompt}</MathContent>}
                {exercise.question && <MathContent>{exercise.question}</MathContent>}
            </Header>
            {exercise.options.map((option, index) => {
                const answered = selectedAnswers && selectedAnswers.find((item) => item.id === option.id);
                const answerType = answered ? answered.type : option.correct ? 'missing' : '';
                return (
                    <SingleMultipleChoiceCorrection
                        key={index}
                        answerType={answerType}
                        text={option.text}
                        feedback={option.feedback}
                        index={index}
                        solution={solution}
                    />
                );
            })}
        </AnswersContainer>
    );
};
MultipleChoiceCorrection.propTypes = exercisePropTypes.propTypes;

export default MultipleChoiceCorrection;
